// One-time upload disclaimer (UX-S4-6, Q2). Версионированный localStorage-ключ —
// при изменении копи дисклеймера юристом меняем версию → старые пользователи
// видят новую формулировку. Source of truth: docs/specs/sprint-4/stage-4-frontend.md §3.3.

const KEY = 'healthlab:upload_disclaimer_seen:v1';

export function hasSeenUploadDisclaimer(): boolean {
  try {
    return localStorage.getItem(KEY) === '1';
  } catch {
    return false;
  }
}

export function markUploadDisclaimerSeen(): void {
  try {
    localStorage.setItem(KEY, '1');
  } catch {
    // Safari private mode / WebView QuotaExceededError — допустимо повторить дисклеймер.
  }
}
